import Footer from "./Homepages/Footer";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { themes } from "../reducers/userReducer";
import { useDispatch } from "react-redux";

export default function Settings() {
  const [settingsColor, setColor] = useState("#3AB0FF");
  const dispatch = useDispatch();
  const darkTheme = (value) => {
    dispatch(themes({ background: "#17181E", text: "#fff" }));
  };
  const lightTheme = (value) => {
    dispatch(themes({ background: "#fff", text: "#000" }));
  };

  const navigate = useNavigate();
  return (
    <div className="container px-4 mb-5">
      <div className="heading mb-3 mt-4">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/home");
          }}
        />
        <h3 className="text-center no-wrap">Settings</h3>
      </div>
      <div className="container mb-5 p-3" id="setting">
        <h2>Theme</h2>
        <div className="form-check">
        <input
            type="radio"
            className="btn-check"
            name="options"
            id="option1"
            autocomplete="off"
            onClick={()=>{lightTheme()}}
          />
          <label className="btn bg-light" for="option1">
            <h5>&#9674; Light</h5>
          </label>
        </div>
        <div className="form-check">
          <input
            type="radio"
            className="btn-check"
            name="options"
            id="option2"
            autocomplete="off"
            onClick={()=>{darkTheme()}}
          />
          <label className="btn" for="option2">
          <h5>&#9674; Dark</h5>
          </label>
        </div>
      </div>
      <Footer settingsColor={settingsColor} />
    </div>
  );
}
